export default "__VITE_ASSET__GQLXJKLx__"